/**
 * Takes a string and returns a short preview
 *
 * @param message - initial message
 * @param maxLength - max parsed length
 */
export const parseMessagePreview = (message: string, maxLength = 15) => {
  if (!message) return '';

  // replace newLine with 2 spaces
  const parsed = message.replace('\n', '  ');

  if (parsed.length <= maxLength) return parsed;

  const trailing = '..';
  return parsed.slice(0, maxLength - trailing.length) + trailing;
};
